import {Component} from '@angular/core';

@Component({
  selector: 'rmi-ivr-analysis-report-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent {
}
